var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pricing-import',{staticClass:"flyer-pricing-import",attrs:{"formName":"flyer-pricing-import","moduleSlug":"flyer-pricing-import","controllerName":"FlyerPricingImport.vue","moduleName":"Flyer Pricing Import","priceTypeId":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }